import "./style.moduleRenamed.css";

export const tooltip = "style-module__tooltip___QZMza";
export const hide = "style-module__hide___Jm4Hg";
export const checkBox = "style-module__checkBox___9Z1W0";

export default {
  tooltip: "style-module__tooltip___QZMza",
  hide: "style-module__hide___Jm4Hg",
  checkBox: "style-module__checkBox___9Z1W0",
};